import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Modal, SlideUpPanel, Text } from "@cinch-labs/design-system";
import React, { useState } from "react";
import { groupDestinations, setupPreferences } from "../../utils";
import styles from "./cookie-preferences-modal.module.css";
var CookiePreferencesModal = function(param) {
    var segmentPreferences = param.segmentPreferences, destinationPreferences = param.destinationPreferences, existingCookiePreferences = param.existingCookiePreferences, onSaveCookiePreferences = param.onSaveCookiePreferences, onClose = param.onClose;
    var isMobile = (window === null || window === void 0 ? void 0 : window.innerWidth) <= 767;
    var ModalComponent = isMobile ? SlideUpPanel : Modal;
    var ref = useState(existingCookiePreferences), userCookiePreferences = ref[0], setUserCookiePreferences = ref[1];
    var categoryPreferences = setupPreferences(segmentPreferences.getDestinationsGroupedByCategory());
    var cinchCategoriesNameMapper = {
        "Customer Success": "functional",
        Advertising: "advertising",
        Analytics: "analytics"
    };
    var isCategoryChecked = function(category) {
        var categoryName = cinchCategoriesNameMapper[category];
        return userCookiePreferences && userCookiePreferences[categoryName];
    };
    var handleCheckboxChange = function(category, event) {
        var selectedDestinations = segmentPreferences.getSelectedDestinations(destinationPreferences);
        var destinationsGroupedByCategory = groupDestinations(selectedDestinations, "category");
        var selectedCategoryDestinationsExist = !!destinationsGroupedByCategory[category];
        // No idea what this second param is doing, looks like it was always set up to pass false and I'm not sure that's right..
        segmentPreferences.setCategoryPreference(category, selectedCategoryDestinationsExist ? false : true);
        // Update local state for user preferences
        var categoryName = cinchCategoriesNameMapper[category];
        var isChecked = event.target.checked;
        var updatedUserPreferences = _object_spread_props(_object_spread({}, userCookiePreferences), _define_property({}, categoryName, isChecked));
        setUserCookiePreferences(_object_spread({}, existingCookiePreferences, updatedUserPreferences));
    };
    return /*#__PURE__*/ _jsx(ModalComponent, {
        heading: "My preferences",
        onClose: onClose,
        ariaLabelledById: "my-preferences-".concat(isMobile ? "slide-up" : "modal"),
        "data-testid": "".concat(isMobile ? "slide-up" : "main", "-modal"),
        primaryButtonText: "Save preferences",
        primaryButtonOnClick: function() {
            localStorage.setItem("updatedCookiePreferences", JSON.stringify(userCookiePreferences));
            onSaveCookiePreferences(userCookiePreferences);
        },
        children: categoryPreferences.map(function(preference, key) {
            /*#__PURE__*/ return _jsxs("div", {
                className: styles.preferencesSection,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.preferencesSectionHeader,
                        children: [
                            (preference === null || preference === void 0 ? void 0 : preference.category) && /*#__PURE__*/ _jsx(Checkbox, {
                                label: "",
                                type: "checkbox",
                                id: cinchCategoriesNameMapper[preference.category],
                                name: preference.category,
                                value: preference.category,
                                checked: isCategoryChecked(preference.category),
                                onChange: function(e) {
                                    return (preference === null || preference === void 0 ? void 0 : preference.category) ? handleCheckboxChange(preference.category, e) : null;
                                },
                                "data-testid": "checkbox-".concat(cinchCategoriesNameMapper[preference.category])
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSizeFixed: "xs",
                                fontWeight: "bold",
                                lineHeight: "display",
                                className: styles.preferencesSectionHeading,
                                children: preference.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        fontSizeFixed: "xs",
                        className: styles.preferencesBody,
                        children: preference.purpose
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        fontSizeFixed: "xs",
                        children: preference.tools.join(", ")
                    })
                ]
            }, key);
        })
    });
};
export default CookiePreferencesModal;
